import React from 'react';
import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from "lucide-react";

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  background-color: ${props => props.disabled ? '#3a3a3a' : '#4a4a4a'};
  color: ${props => props.disabled ? '#777' : 'white'};
  border: none;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  
  &:hover {
    background-color: ${props => props.disabled ? '#3a3a3a' : '#5a5a5a'};
  }
`;

const PaginationInfo = styled.div`
  color: white;
  font-size: 14px;
`;

const StyledSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Pagination = ({ 
  vendor, 
  pagination, 
  onPagination 
}) => {
  if (!pagination || !onPagination) {
    return null;
  }

  const { currentPage, totalPages, loading } = pagination;

  return (
    <PaginationContainer>
      <PaginationButton
        onClick={() => onPagination(vendor, 'prev')}
        disabled={currentPage <= 1 || loading}
      >
        <ChevronLeft size={16} /> Previous
      </PaginationButton>

      <PaginationInfo>
        Page {currentPage} of {totalPages}
      </PaginationInfo>

      <PaginationButton
        onClick={() => onPagination(vendor, 'next')}
        disabled={currentPage >= totalPages || loading}
      >
        Next <ChevronRight size={16} />
      </PaginationButton>

      {loading && <StyledSpinner />}
    </PaginationContainer>
  );
};

export default Pagination;
